import { Appointment } from "../calendar/interfaces/appointment";
import { AppointmentDto } from "../calendar/interfaces/appointment_dto";

export function convertAppointments(appointments: AppointmentDto[]): Appointment[] {
    if (appointments === null || appointments === undefined || appointments?.length === 0) return [];
    return appointments.map((appointment) => {
        return {
            // remove time zone offset from appointment.StartTime and appointment.EndTime with toISOString()
            start_time: new Date(new Date(appointment.StartTime).setTime(new Date(appointment.StartTime).getTime() - new Date(appointment.StartTime).getTimezoneOffset() * 60 * 1000)),
            end_time: new Date(new Date(appointment.EndTime).setTime(new Date(appointment.EndTime).getTime() - new Date(appointment.EndTime).getTimezoneOffset() * 60 * 1000)),
            subject: appointment.Subject,
            is_all_day: appointment.IsAllDay,
            recurrence_rule: appointment.RecurrenceRule,
            recurrence_id: appointment.RecurrenceID,
            recurrence_exception: appointment.RecurrenceException,
            notes: appointment.Description,
            guid: appointment.Guid,
            student: appointment.Student,
            invoice: appointment.Invoice,
            location: appointment.Location,
            start_mileage: appointment.StartMileage,
            end_mileage: appointment.EndMileage,
            type: appointment.Type,
            prize: appointment.Prize,
            lessons: appointment.Lessons,
            passed_test: appointment.PassedTest,
            education_notes: appointment.EducationNotes,
            invoice_id: appointment.InvoiceId,
            student_id: appointment.StudentId,
            service_id: appointment.ServiceId,
            instructor_id: null,
            user_id: null,
            mail_id: appointment.MailId,
            sms_reminder: appointment.SmsReminder,
            google_id: appointment.GoogleId,
            subscription_payment: appointment.SubscriptionPayment,
            local_calendar_id: appointment.LocalCalendarId,
        };
    });
}

export function convertAppointment(appointment: AppointmentDto): Appointment {
    if (appointment === null || appointment === undefined) return null;
    return {
        start_time: new Date(new Date(appointment.StartTime).setTime(new Date(appointment.StartTime).getTime() - new Date(appointment.StartTime).getTimezoneOffset() * 60 * 1000)),
        end_time: new Date(new Date(appointment.EndTime).setTime(new Date(appointment.EndTime).getTime() - new Date(appointment.EndTime).getTimezoneOffset() * 60 * 1000)),
        subject: appointment.Subject,
        is_all_day: appointment.IsAllDay,
        recurrence_rule: appointment.RecurrenceRule,
        recurrence_id: appointment.RecurrenceID,
        recurrence_exception: appointment.RecurrenceException,
        notes: appointment.Description,
        guid: appointment.Guid,
        student: appointment.Student,
        invoice: appointment.Invoice,
        location: appointment.Location,
        type: appointment.Type,
        prize: appointment.Prize,
        lessons: appointment.Lessons,
        passed_test: appointment.PassedTest,
        education_notes: appointment.EducationNotes,
        start_mileage: appointment.StartMileage,
        end_mileage: appointment.EndMileage,
        invoice_id: appointment.InvoiceId,
        student_id: appointment.StudentId,
        service_id: appointment.ServiceId,
        instructor_id: null,
        user_id: null,
        mail_id: appointment.MailId,
        sms_reminder: appointment.SmsReminder,
        google_id: appointment.GoogleId,
        subscription_payment: appointment.SubscriptionPayment,
        local_calendar_id: appointment.LocalCalendarId,
    };
}

export function convertAppointmentDto(appointment: Appointment): AppointmentDto {
    if (appointment === null || appointment === undefined) return null;
    return {
        Id: appointment.appointment_id,
        StartTime: new Date(appointment.start_time),
        EndTime: new Date(appointment.end_time),
        Subject: appointment.subject,
        IsAllDay: appointment.is_all_day,
        RecurrenceRule: appointment.recurrence_rule,
        RecurrenceID: appointment.recurrence_id,
        RecurrenceException: appointment.recurrence_exception,
        Description: appointment.notes,
        Guid: appointment.guid,
        Student: appointment.student,
        StudentId: appointment.student_id,
        Invoice: appointment.invoice,
        Location: appointment.location,
        Type: appointment.type,
        StartMileage: appointment.start_mileage,
        EndMileage: appointment.end_mileage,
        PassedTest: appointment.passed_test,
        EducationNotes: appointment.education_notes,
        InvoiceId: appointment.invoice_id,
        Prize: appointment.prize,
        Lessons: appointment.lessons,
        MailId: appointment.mail_id,
        ResourceId: "quickdrive.ch",
        SmsReminder: appointment.sms_reminder,
        GoogleId: appointment.google_id,
        SubscriptionPayment: appointment.subscription_payment,
        ServiceId: appointment.service_id,
        LocalCalendarId: appointment.local_calendar_id,
    };
}

export function convertAppointmentsDto(appointments: Appointment[]): AppointmentDto[] {
    if (appointments === null || appointments === undefined || appointments?.length === 0) return [];
    return appointments.map((appointment) => {
        return {
            Id: appointment.appointment_id,
            StartTime: new Date(appointment.start_time),
            EndTime: new Date(appointment.end_time),
            Subject: appointment.subject,
            IsAllDay: appointment.is_all_day,
            RecurrenceRule: appointment.recurrence_rule,
            RecurrenceID: appointment.recurrence_id,
            RecurrenceException: appointment.recurrence_exception,
            Description: appointment.notes,
            Guid: appointment.guid,
            Student: appointment.student,
            StudentId: appointment.student_id,
            Invoice: appointment.invoice,
            Location: appointment.location,
            StartMileage: appointment.start_mileage,
            EndMileage: appointment.end_mileage,
            Type: appointment.type,
            PassedTest: appointment.passed_test,
            EducationNotes: appointment.education_notes,
            InvoiceId: appointment.invoice_id,
            Prize: appointment.prize,
            Lessons: appointment.lessons,
            MailId: appointment.mail_id,
            ResourceId: "quickdrive.ch",
            SmsReminder: appointment.sms_reminder,
            GoogleId: appointment.google_id,
            SubscriptionPayment: appointment.subscription_payment,
            ServiceId: appointment.service_id,
            LocalCalendarId: appointment.local_calendar_id,
        };
    });
}